import Label from "../../../components/Label";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { findIconDefinition, IconLookup, library } from "@fortawesome/fontawesome-svg-core";
import { BASE_PATH } from '../../../config'
import usePicking from "../../../hooks/data/usePicking";
import useReceiving from "../../../hooks/data/useReceiving";
import useStockCount from "../../../hooks/data/useStockCount";
import { fas } from "@fortawesome/pro-solid-svg-icons";
import { NavConfig } from "../../../components/nav-section/type";
import useClientConfig from "../../../hooks/bx/useClientConfig";
import useWebShopStore from "../../../stores/useWebShopStore";

library.add(fas);

const getIcon = (name: IconLookup) => (
    <FontAwesomeIcon
        icon={findIconDefinition(name)}
    />
);

const ICONS = {
    devices: getIcon({ prefix: "fas", iconName: "calculator" }),
    receivingMonitor: getIcon({ prefix: "fas", iconName: "sign-in-alt" }),
    pickingMonitor: getIcon({ prefix: "fas", iconName: "sign-out-alt" }),
    location: getIcon({ prefix: "fas", iconName: "map-marker" }),
    stockCount: getIcon({ prefix: "fas", iconName: "cubes" }),
    labelDesigner: getIcon({ prefix: "fas", iconName: "object-group" }),
    stockOverview: getIcon({ prefix: "fas", iconName: "cube" }),
    labels: getIcon({ prefix: "fas", iconName: "tags" }),
    logout: getIcon({ prefix: "fas", iconName: "lock" }),
    home: getIcon({ prefix: "fas", iconName: "home" }),
    webshop: getIcon({ prefix: 'fas', iconName: 'shopping-cart' }),
    webshopBasket: getIcon({ prefix: 'fas', iconName: 'credit-card' }),
    webshopHistory: getIcon({ prefix: 'fas', iconName: 'history' }),
    genericReports: getIcon({ prefix: "fas", iconName: "book" }),
    assetsmanager: getIcon({ prefix: "fas", iconName: "archive" }),
    shipmentmanager: getIcon({ prefix: "fas", iconName: "truck" }),
    deliveryManager: getIcon({ prefix: "fas", iconName: "project-diagram" }),
};

const StockCountInfo = ({ ...others }) => {
    const { totalCount } = useStockCount();

    if (!totalCount) return null;

    return <Label variant={"outlined"} color="error" {...others}>+{totalCount}</Label>
}

const PickingInfo = ({ ...others }) => {
    const { totalCount } = usePicking();

    if (!totalCount) return null;

    return <Label variant={"outlined"} color="error" {...others}>+{totalCount}</Label>
}

const ReceivingInfo = ({ ...others }) => {
    const { totalCount } = useReceiving();

    if (!totalCount) return null;

    return <Label variant={"outlined"} color="info" {...others}>+{totalCount}</Label>
}

const BasketInfo = ({ ...others }) => {
    const basket = useWebShopStore(state => state.basket);

    if (basket.length === 0) return null;

    return <Label variant={"outlined"} color="info" {...others}>+{basket.length}</Label>
}

const useNavConfig = () => {

    const { webmanager } = useClientConfig();

    const navConfig: NavConfig[] = [
        {
            subheader: "general",
            hidden: webmanager.showwebshop,
            items: [
                { title: "Home", path: BASE_PATH + "/home", icon: ICONS.home },
            ],
        },
        {
            subheader: "labels",
            hidden: webmanager.showwebshop || !webmanager.showlabels,
            items: [
                { title: "Products", path: BASE_PATH + "/labels/products", icon: ICONS.labels },
                {
                    title: "Locations",
                    path: BASE_PATH + "/labels/locations",
                    icon: ICONS.location,
                },
                // {
                //     title: "Designer",
                //     disabled: true,
                //     path: BASE_PATH + "/manager/labels123",
                //     icon: ICONS.labelDesigner,
                // },
            ],
        },
        {
            subheader: "warehouse",
            hidden: webmanager.showwebshop || (!webmanager.showstockcount && !webmanager.showstockoverview),
            items: [
                ...(webmanager.showstockcount ? [{
                    title: "Stock Count",
                    path: BASE_PATH + "/stockcount",
                    icon: ICONS.stockCount,
                    info: <StockCountInfo/>
                }] : []),
                ...(webmanager.showstockoverview ? [{
                    title: "Stock Overview",
                    path: BASE_PATH + "/labels/stockoverview",
                    icon: ICONS.stockOverview,
                }] : []),
                ...(webmanager.showdeliverymanager ? [{
                    title: "Delivery Manager",
                    path: BASE_PATH + "/deliverymanager/products",
                    icon: ICONS.deliveryManager,
                }] : []),

            ],
        },
        {
            subheader: "Monitor",
            hidden: webmanager.showwebshop || (!webmanager.showpickingmonitor && !webmanager.show),
            items: [
                {
                    title: "Picking",
                    path: BASE_PATH + "/monitor/picking",
                    icon: ICONS.pickingMonitor,
                    info: <PickingInfo/>,
                },
                {
                    title: "Receiving",
                    path: BASE_PATH + "/monitor/receiving",
                    icon: ICONS.receivingMonitor,
                    info: <ReceivingInfo/>
                },
                // {
                //     title: "Devices",
                //     path: BASE_PATH + "/manager/labels123",
                //     icon: ICONS.labelDesigner,
                // },
            ],
        },
        {
            subheader: "Assets",
            hidden: !webmanager.showassetsmanager,
            items: [
                {
                    title: "Manager",
                    path: BASE_PATH + "/assets/manager",
                    icon: ICONS.assetsmanager
                },
            ]
        },
        {
            subheader: "Reports",
            hidden: !webmanager.genericreports,
            items: webmanager?.genericreports?.split(',').map((reportName: string) => (
                {
                    title: reportName,
                    path: BASE_PATH + "/reports/" + reportName.toLowerCase(),
                    icon: ICONS.genericReports
                }
            )) || []
        },

        {
            subheader: "Webshop",
            hidden: !webmanager.showwebshop,
            items: [
                {
                    title: "Webshop",
                    path: BASE_PATH + "/webshop/products",
                    icon: ICONS.webshop
                },
                {
                    title: "Basket",
                    path: BASE_PATH + "/webshop/basket",
                    icon: ICONS.webshopBasket,
                    info: <BasketInfo/>
                },
                {
                    title: "History",
                    path: BASE_PATH + "/webshop/history",
                    icon: ICONS.webshopHistory,
                },
            ],
        },


        //Custom
        {
            subheader: "Custom",
            hidden: !webmanager.plugin_raumaullvare && !webmanager.plugin_norgescatering,
            items: [
                ...(webmanager.plugin_raumaullvare ? [{
                    title: "Rauma Ullvare",
                    path: BASE_PATH + "/plugins/raumaullvare",
                    icon: ICONS.genericReports,
                }] : []),
                ...(webmanager.plugin_norgescatering ? [{
                    title: "Norges Catering",
                    path: BASE_PATH + "/plugins/norgescatering",
                    icon: ICONS.genericReports,
                }] : []),
            ]
        }
    ]

    return ({
        navConfig: navConfig
    })
}

export default useNavConfig